<template>
  <v-card
    v-if="variant === 'expand-summary'"
    class="rounded-lg pa-3 position-relative"
    outlined
    elevation="1"
    :color="colorCard"
  >
    <div
      class="d-flex justify-space-between align-center"
      @click="$emit('toggle')"
    >
      <div class="d-flex align-center pr-1" style="gap: 20px">
        <PointSymbol
          :type="item.point_type_type"
          :symbol="item.point_type_symbol"
          :color="item.point_type_color"
          :is_display="true"
          :outlined_box="false"
          :size="40"
        />
        <div>
          <div>
            <span
              style="font-size: 24px"
              class="font-weight-bold"
              :style="{ color: site.color }"
            >
              {{ item.point | commaPoint }}
            </span>
          </div>
          <div>
            <span class="black--text">{{ item.point_type_name }}</span>
          </div>
        </div>
      </div>

      <v-icon
        class="my-point-card__chevron"
        :class="{ 'my-point-card__chevron--open': expanded }"
        :color="site.color"
      >
        mdi-chevron-down
      </v-icon>
    </div>
  </v-card>

  <v-card
    v-else-if="variant === 'breakdown'"
    class="rounded-lg pa-3 position-relative mt-2 mx-auto"
    outlined
    elevation="1"
    :color="colorCardSplit"
    width="95%"
  >
    <v-chip
      v-if="history.point_expire_date"
      small
      label
      class="font-weight-medium my-point-card__expand-sub-chip"
      :style="chipStyles"
    >
      {{ $t("expiredAt") }} {{ history.point_expire_date | formatDate }}
    </v-chip>
    <div class="d-flex align-center pr-1" style="gap: 20px">
      <PointSymbol
        :type="item.point_type_type"
        :symbol="item.point_type_symbol"
        :color="item.point_type_color"
        :is_display="true"
        :outlined_box="false"
        :size="40"
      />
      <div>
        <div>
          <span
            style="font-size: 24px"
            class="font-weight-bold"
            :style="{ color: site.color }"
          >
            {{ history.point | commaPoint }}
          </span>
        </div>
        <div>
          <span class="black--text">{{ item.point_type_name }}</span>
        </div>
      </div>
    </div>
  </v-card>

  <v-card
    v-else
    class="rounded-lg pa-3 position-relative"
    outlined
    elevation="1"
    :color="colorCard"
  >
    <v-chip
      v-if="expireDate"
      small
      label
      class="font-weight-medium my-point-card__expire-chip"
      :style="chipStyles"
    >
      {{ $t("expiredAt") }} {{ expireDate | formatDate }}
    </v-chip>

    <div class="d-flex justify-space-between align-center">
      <div class="d-flex align-center pr-1" style="gap: 20px">
        <PointSymbol
          :type="item.point_type_type"
          :symbol="item.point_type_symbol"
          :color="item.point_type_color"
          :is_display="true"
          :outlined_box="false"
          :size="40"
        />
        <div>
          <div>
            <span
              style="font-size: 24px"
              class="font-weight-bold"
              :style="{ color: site.color }"
            >
              {{ item.point | commaPoint }}
            </span>
          </div>
          <div>
            <span class="black--text">{{ item.point_type_name }}</span>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import PointSymbol from "@/components/point/point-symbol.vue";
import { blendColorWithWhite } from "@/config/general-function";

export default {
  name: "MyPointCard",
  components: { PointSymbol },
  props: {
    variant: {
      type: String,
      required: true,
      validator: (v) => ["expand-summary", "breakdown", "flat"].includes(v),
    },
    item: { type: Object, required: true },
    expanded: { type: Boolean, default: false },
    history: {
      type: Object,
      default: () => ({}),
    },
    chipStyles: {
      type: Object,
      default: () => ({}),
    },
    expireDate: { type: String, default: null },
  },

  filters: {
    commaPoint(value) {
      if (value == 0) return "0";
      if (value) return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return "0";
    },
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("DD MMM YYYY");
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    colorCard() {
      let themeColor = (this.site && this.site.color) || "#f2c00e";
      themeColor = blendColorWithWhite(themeColor, 0.2);
      return themeColor;
    },
    colorCardSplit() {
      let themeColor = (this.site && this.site.color) || "#f2c00e";
      themeColor = blendColorWithWhite(themeColor, 0.1);
      return themeColor;
    },
  },
};
</script>

<style scoped>
.my-point-card__chevron {
  transition: transform 0.55s cubic-bezier(0.22, 1, 0.36, 1);
}

.my-point-card__chevron--open {
  transform: rotate(180deg);
}

.my-point-card__expand-sub-chip {
  position: absolute;
  top: 8px;
  right: 8px;
  max-width: calc(100% - 16px);
}

.my-point-card__expire-chip {
  position: absolute;
  top: 8px;
  right: 8px;
}

@media (prefers-reduced-motion: reduce) {
  .my-point-card__chevron {
    transition-duration: 0.01ms;
  }
}
</style>
